<div class="container-fluid py-4">
  <div class="row">

    @if (energySettings) {
      <div class="col-12 col-sm-6 mb-2">
        <div class="card mb-4">
          <div class="card-header lw-gradient-text bg-secondary text-center">
            Personal Information
          </div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item d-flex justify-content-between align-items-center">
              Email Address
              <span class="text-grey">{{user.userDetail.user.email}}</span>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-center">
              Joined Date
              <span class="text-grey">{{user.userDetail.user.created | date: 'medium'}}</span>
            </li>
          </ul>
        </div>
        @if (settings) {
          <div class="card mb-4">
            @for (block of settings; track block) {
              <div>
                <div class="card-header lw-gradient-text bg-secondary text-center">
                  {{block.label}}
                </div>
                <div class="card">
                  @for (itemValue of block.items; track itemValue; let i = $index) {
                    <div class="settings-box w-100 p-3" (click)="openDialog(itemValue)">
                      {{itemValue.label}}
                      <span class="value-box">
                        @if (itemValue.type==='select') {
                          <div class="dropdown" (ldsClickOutSide)="itemValue.toggle=false">
                            <button class="btn btn-default dropdown-toggle" type="button" (click)="itemValue.toggle = !itemValue.toggle">
                              {{itemValue.value}}
                            </button>
                            <div class="dropdown-menu" [ngClass]="itemValue.toggle ? 'show' : ''" aria-labelledby="dropdownMenuButton">
                              @for (choice of itemValue.available; track choice) {
                                <a class="dropdown-item" (click)="clicked(itemValue, choice)">{{choice}}</a>
                              }
                            </div>
                          </div>
                        }
                        @if (!itemValue.type) {
                          <div>{{itemValue.value}}</div>
                        }
                      </span>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    }



    <div class="col-12 col-sm-6 mb-2">
      <div class="card">
        <div class="card-header lw-gradient-text bg-secondary text-center">
          Devices
        </div>
        <ul class="list-group list-group-flush">
          @for (item of deviceTypes; track item) {
            <li class="list-group-item d-flex justify-content-between align-items-center">
              {{item.label}}
              <span class="badge lw-badge badge-pill">{{item.value}}</span>
            </li>
          }
        </ul>
      </div>
    </div>


  </div>
</div>
